// Vue
import { Component, Vue } from "vue-property-decorator";
// Mobx
import { autorun } from "mobx";
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Enums

import "#/modules/index.ts";
import { User } from "@mgs/ci2019-common/src/models/user/User";
import { IRegion } from "@mgs/ci2019-common/src/interfaces/IRegion";
import { Api } from "#/api";
import {
  deleteCookie,
  getCookie,
  parsePlaceholderText,
  setCookie,
} from "#/common/Utils";
import { HeadlineNews } from "../../../components/headline_news/HeadlineNews";
import { ConversionworldMenu } from "../../../components/conversionworld_menu/ConversionworldMenu";
import { ConversionworldSearchLayer } from "../../../components/conversionworld_search_layer/ConversionworldSearchLayer";
import { Language } from "@mgs/ci2019-common/src/enums/Language";

@Observer
@Component({
  mixins: [template],
  components: {
    HeadlineNews,
    ConversionworldMenu,
    ConversionworldSearchLayer,
  },
})
export class ConversionworldLayout extends Vue {
  private isMobileMenuOpen = false;

  private activeFlyout = "";

  isCountryCookieModalOpen = false;

  activeOverlay: string = "";

  created() {
    this.$eventBus.$on(
      "conversion-world-open-search-layer",
      this.handleOpenSearchLayer
    );

    const urlParams = new URLSearchParams(window.location.search);
    let preview = !!urlParams.get("preview");

    const forceUrl = urlParams.get("forceUrl");

    if (forceUrl) {
      const forceUrlSearch = new URL(forceUrl).search;
      preview = !!new URLSearchParams(forceUrlSearch).get("preview");
    }

    if (!preview) {
      if (getCookie("country")) {
        if (getCookie("country") !== this.$store.ui.appCurrentCountry) {
          this.isCountryCookieModalOpen = true;
        }
      } else {
        if (this.$store.ui.appCurrentCountry === "GLOBAL") {
          this.activeOverlay = "regions";
        } else {
          setCookie(
            "country",
            this.$store.ui.appCurrentCountry.toUpperCase(),
            12 * 7 //12 Wochen
          );
        }
      }
    }
  }

  mounted() {}

  beforeDestroy() {
    this.$eventBus.$off(
      "conversion-world-open-search-layer",
      this.handleOpenSearchLayer
    );
  }

  public handleOpenSearchLayer() {
    this.activeFlyout = "search";
  }

  public handleBodyPaddingChanged(padding: number) {
    this.$store.ui.bodyPadding = padding;
  }

  public handleActiveOverlay(overlay) {
    /*if (overlay) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }*/
  }

  public get headerOptions() {
    return {
      topMenuBefore: [],
      menu: [
        {
          id: "search",
          overlay: true,
          icon: this.$icons.SEARCH,
          text: (this as any).$t("HEADER_CW_SEARCH"),
        },
        {
          id: "menu",
          overlay: true,
          icon: this.$icons.MENU,
          text: (this as any).$t("HEADER_CW_MENU"),
        },
      ],
    };
  }

  changeCountry(event: any) {
    setCookie("country", event.krzl.toUpperCase(), 12 * 7 /* 12 Wochen */);
  }

  saveCountryCookie() {
    setCookie(
      "country",
      this.$store.ui.appCurrentCountry.toUpperCase(),
      12 * 7 //12 Wochen
    );
    this.isCountryCookieModalOpen = false;
  }

  goToSavedPage() {
    let pathArray = window.location.pathname.split("/");
    pathArray[2] = getCookie("country").toUpperCase();

    window.location.href = pathArray.join("/") + window.location.search;
  }

  public handleFooterClick(itemName: string) {
    // @ts-ignore
    this.$refs["Header"].openPolicy(itemName);
  }

  public handleCookieAccept(accepted: boolean) {
    if (accepted) {
      // @ts-ignore
      window._paq.push(["rememberConsentGiven"]);
    }

    Api.authService.updateTrackingStatus(accepted);
    // @ts-ignore
    this.$refs["CookieLayer"].handleAgree();
  }

  public parseCookieLinkText(text: string, start: string, end: string) {
    return parsePlaceholderText(text, start, end);
  }

  public handleIsMobileMenuOpen(event) {
    this.isMobileMenuOpen = event;
  }

  public onCloseMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  public handleActiveFlyout(id) {
    this.activeFlyout = id;
    if (id === "menu" || id === "search") {
      this.isMobileMenuOpen = true;

      if (id === "search") {
        Vue.nextTick(() => {
          // @ts-ignore
          this.$refs["searchLayer"].focusInput();
        });
      }
    } else {
      this.isMobileMenuOpen = false;
    }
  }

  changeLanguage(event) {
    setCookie("language", event.code, 0.5);
  }
}
